// eslint-disable-next-line no-unused-vars
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respDataCategory: null,
    respData: null,
  },
  getters: {
  },
  mutations: {
    GET_CATEGORY(state, payload) {
      state.respDataCategory = payload
    },
    ADD_CATEGORY(state, payload) {
      if (state.respDataCategory != null) {
        state.respDataCategory.data.push(payload)
        // eslint-disable-next-line operator-assignment
        state.respDataCategory.max = state.respDataCategory.max + 1
      } else {
        state.respDataCategory.data = [payload]
        state.respDataCategory.max = 1
      }
    },
    UPDATE_CATEGORY(state, payload) {
      const productIndex = state.respDataCategory.data.findIndex(p => p._id === payload._id)
      Object.assign(state.respDataCategory.data[productIndex], payload)
    },
    REMOVE_CATEGORY(state, id) {
      if (state.respDataCategory != null) {
        const ItemIndex = state.respDataCategory.data.findIndex(p => p._id === id)
        state.respDataCategory.data.splice(ItemIndex, 1)
        // eslint-disable-next-line operator-assignment
        state.respDataCategory.max = state.respDataCategory.max - 1
      }
    },
    GET(state, payload) {
      state.respData = payload
    },
    ADD(state, payload) {
      if (state.respData != null) {
        state.respData.data.push(payload)
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max + 1
      } else {
        state.respData.data = [payload]
        state.respData.max = 1
      }
    },
    UPDATE(state, payload) {
      const productIndex = state.respData.data.findIndex(p => p._id === payload._id)
      Object.assign(state.respData.data[productIndex], payload)
    },
    REMOVE(state, id) {
      if (state.respData != null) {
        const ItemIndex = state.respData.data.findIndex(p => p._id === id)
        state.respData.data.splice(ItemIndex, 1)
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max - 1
      }
    },
    SWITCH_CHANGE(state, item) {
      const ItemIndex = state.respData.data.findIndex(p => p._id === item.id)
      if (ItemIndex > -1) {
        const nameChild = item.name.split('.')
        console.log(nameChild)
        if (nameChild.length === 3) {
          state.respData.data[nameChild[0]][nameChild[1]][nameChild[2]] = item.status
        } else if (nameChild.length === 2) {
          state.respData.data[nameChild[0]][nameChild[1]] = item.status
        } else {
          state.respData.data[item.name] = item.status
        }
      }
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getCategory({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/hero/coupon/getCategory?pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET_CATEGORY', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    addCategory({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('/api/web/application/hero/coupon/addCategory', item)
          .then(response => {
            commit('ADD_CATEGORY', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateCategory({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/application/hero/coupon/updateCategory', item)
          .then(response => {
            commit('UPDATE_CATEGORY', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    deleteCategory({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/web/application/hero/coupon/deleteCategory?id=${item}`)
          .then(response => {
            commit('REMOVE_CATEGORY', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    get({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/hero/coupon/get?pageSize=${item.pageSize}&currentPage=${item.currentPage}&categoryCouponId=${item.categoryCouponId}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    add({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('/api/web/application/hero/coupon/add', item)
          .then(response => {
            commit('ADD', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    update({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/application/hero/coupon/update', item)
          .then(response => {
            commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    delete({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/web/application/hero/coupon/delete?id=${item}`)
          .then(response => {
            commit('REMOVE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

  },
}
